<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col
        class="logo"
        style="minWidth:209px;"
        :class="collapsed?'logo-collapse-width':'logo-width'"
      >
        <img src="../../src/assets/logo.png" />
      </el-col>
      <el-col :span="21" style="minWidth:1400px;">
        <el-col class="f16" :span="1" style="textAlign:right">
          <router-link style="color:#666" :to="'/'">
            <i class="el-icon-s-home"></i> 主页
          </router-link>
        </el-col>
        <el-col :span="4" style="textAlign:right;" :offset="18">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link userinfo-inner f16">
              <i class="el-icon-user-solid f16"></i>
              您好，{{sysUserName}}
              <i class="el-icon-caret-bottom"></i>
              <!-- <img v-if="role!='root'" :src="'http://zlesp.zlydgy.cn:8091/images/'+this.logoUrl" alt />
              <img v-else src="../../src/assets/user.png" /> -->
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>我的消息</el-dropdown-item> -->
              <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
              <!-- <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="1" style="textAlign:right;float:right;">
          <span class="f16" @click="logout">
            <i class="el-icon-switch-button"></i> 退出
          </span>
        </el-col>
      </el-col>
    </el-col>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
      <el-form :model="formparam" :rules="rules" ref="formparam" label-width="80px">
        <el-form-item label="密码" prop="password">
          <el-input style="width:300px" v-model="formparam.password" placeholder="6-10位数组字母结合密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:100px" @click="resetForm('formparam')">取 消</el-button>
        <el-button style="width:100px" type="primary" @click="submitSetInfo('formparam')">确 定</el-button>
      </span>
    </el-dialog>
    <el-col :span="24" class="main">
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu
          mode="vertical"
          unique-opened
          :default-active="$route.path"
          background-color="#0087C4"
          text-color="#fff"
          active-text-color="#FFF601"
          router
        >
          <menu-list :routes="permission_routers"></menu-list>
        </el-menu>
        <!-- <div class="footerText">易思普提供技术支持</div> -->
      </aside>
      <section class="content-container">
        <!-- <div class="content-wrapper"> -->
        <el-breadcrumb separator="/" class="navTop">
          <el-breadcrumb-item
            v-for="(item,index) in realList"
            :key="index"
            :to="item.path"
          >{{item.name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-col :span="24">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-col>
        <!-- </div> -->
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from "vuex";
import menuList from "../components/menuList.vue";
import { getCustomerInfo, updatePassword,getShops } from "../api/configApi.js";
import teacherInfoVue from "./configurable/teacherInfo.vue";
export default {
  data() {
    return {
      sysName: "",
      collapsed: false,
      sysUserName: "",
      role: JSON.parse(sessionStorage.getItem("userinfo")).role,
      realList: [],
      dialogVisible: false,
      rules: {
        password: [
          {
            required: true,
            min: 6,
            max: 10,
            message: "请输入6-10位字母数字结合的密码",
          }, 
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/,
            message: "请输入6-10位字母数字结合的密码",
            trigger: 'change'
          }
        ]
      },
      password:'',
      formparam: {
        password: ""
      },
      logoUrl: ""
    };
  },
  computed: {
    ...mapGetters(["permission_routers"])
  },
  components: {
    menuList
  },
  created(){
    this.getShops()
  },
  methods: {
    getShops(){
      getShops().then((res)=>{
        this.loading = false
        if(res.msg=='success'){
          this.tableData = res.data
          this.shopList = []
          sessionStorage.setItem('shopListAll',JSON.stringify(res.data))
          // for(var i=0;i<res.data.length;i++){
          //     if(res.data[i].isWeb == 1){
          //       this.shopList.push(res.data[i])
          //     }
          // }
          // sessionStorage.setItem('shopList',JSON.stringify(this.shopList))
        }else{
          this.$message.error(res.data)
        }
        
      })
    },
    getConfigInfo() {
      getCustomerInfo().then(res => {
        if (res.msg == "success") {
          sessionStorage.setItem("logo", res.data.logo);
          this.logoUrl = res.data.logo;
        }
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    handleopen() {},
    handleclose() {
      //console.log('handleclose');
    },
    handleselect: function(a, b) {},
    //修改密码
    changePassword() {
      this.dialogVisible = true;
      this.formparam.password = "";
      this.password=''
    },
    submitSetInfo(formparam) {
      this.password = this.formparam.password
      var eles = [];
      eles.push(this.password);
      // var esz = this.encode("0x12",eles);
      this.password = this.common.encode("0x12",eles)  
      this.$refs[formparam].validate(valid => {
        if (valid) {
          updatePassword({password:this.password}).then(res => {
            if (res.msg == "success") {
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "修改成功，请重新登录"
              });
              this.dialogVisible = false;
              setTimeout(()=>{
                this.$router.push({path:'/login'})
              },2000)
            } else {
              this.$message({
                type: "error",
                message: res.data
              });
            }
          });
        } else {
          this.$message.error("请检查必填项");
          return false;
        }
      });
    },
    resetForm(formparam) {
      this.dialogVisible = false;
      this.$refs[formparam].clearValidate();
    },
    //退出登录
    logout() {
      this.$confirm("确认退出吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          //   sessionStorage.removeItem("userinfo");
          //   sessionStorage.removeItem("token");
          //   sessionStorage.removeItem("shopList");
          //   sessionStorage.removeItem("menuList");
          //   sessionStorage.removeItem("limitInfo");
          sessionStorage.clear();
          sessionStorage.setItem("flag", 0);
          this.$router.push("/login");
        })
        .catch(error => {
          this.$message.error("已经取消");
        });
    },
    getinfo(item, index) {
      console.log(item, index);
    },
    //折叠导航栏
    collapse: function() {
      this.collapsed = !this.collapsed;
    },
    showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName(
        "submenu-hook-" + i
      )[0].style.display = status ? "block" : "none";
    },
    getRoutePath() {
      this.realList = this.$route.meta.routeList;
    }
  },
  mounted() {
    // console.log(this.$router.options.routes)
    var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    if (userinfo) {
      this.sysUserName = userinfo.userName;
    }
    this.getRoutePath();
    if (sessionStorage.getItem("logo")) {
      this.logoUrl = sessionStorage.getItem("logo");
    } else {
        if (userinfo.role!='root') {
          this.getConfigInfo();
        }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeList = to.meta.routeList;
    });
  }
};
</script>

<style lang="scss">
// @import '~scss_vars';
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 60px;
    line-height: 60px;
    background: #fff;
    box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.2);
    color: #777;
    display: flex;
    align-items: right;
    .userinfo-inner {
      color: #777;
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      margin: 10px;
      float: right;
    }
    .logo {
      height: 60px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      background: #0087c4;
      img {
        width: 80%;
        float: left;
        margin: 10px 10px 10px 18px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 209px;
    }
    .logo-collapse-width {
      width: 60px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    // background: #0087C4;
    position: absolute;
    top: 60px;
    bottom: 0px;
    // overflow: hidden;
    aside {
      flex: 0 0 209px;
      width: 209px;
      overflow: hidden;
      background: #0087c4;
      .el-menu {
        border-right: none;
        // height: 95%;
        // overflow-y: auto;
        // overflow: hidden;
        // .el-submenu .el-menu-item {
        //   // min-width: 209px;
        // }
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
      .footerText {
        width: 209px;
        text-align: center;
        color: #fff;
        line-height: 30px;
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
      overflow-y: auto;
      overflow-x: hidden;
      // padding-bottom: 60px;
    }
    .menu-expanded {
      flex: 0 0 210px;
      width: 210px;
      overflow-y: auto;
      overflow-x: hidden;
      // padding-bottom: 60px;
    }
    .content-container {
      width: 100%;
      min-width: 1400px;
      position: relative;
      overflow: hidden;
      padding: 20px;
      background: #f2f2f2;
    }
  }
}
element.style {
  padding-left: 20px;
  color: #fff;
  background-color: #0087c4;
}
.el-submenu__title i {
  color: #fff;
}
.el-menu-item i {
  color: #fff;
}
.el-menu-item.is-active {
  color: #fff601;
  background: #2db3f0 !important;
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 8px;
}
</style>


// WEBPACK FOOTER //
// Home.vue?69b838df